'use strict';

var categoriesList = function () {
	var _init = function _init() {
		if (typeof listaCategorias !== 'undefined' && listaCategorias.length > 0) {
			var jsonList = listaCategorias;
			_buildList(jsonList);
		} else {
			$('.js-modelo-vacio').show();
		}
	};

	var _buildList = function _buildList(list) {
		var $container = $('.js-lista-categorias');
		var $tptElem = $('#js-categoria-template');

		$container.empty();

		var _loop = function _loop(i) {
			var item = list[i];
			var $domNode = $tptElem.clone().removeAttr('id');
			var $containerSubCats = $domNode.find('.js-lista-subcat');
			var subcats = item.subcategorias;
			var $button = $domNode.find('.js-selector-subcat');
			var $buttonMobile = $domNode.find('.js-selector-subcat-mobile');

			$domNode.find('.js-nombre-categoria').text(item.nombre.toUpperCase());
			$domNode.find('.js-imagen-categoria').attr({
				'src': 'img/' + item.imagen,
				'alt': item.nombre
			});

			// Subcategorias
			$containerSubCats.empty();

			for (var _i = 0; _i < subcats.length; _i++) {
				subcat = subcats[_i];
				$li = $('<li/>');
				$link = $('<a/>').attr('href', subcat.link).text(subcat.nombre);
				$containerSubCats.append($li.append($link));
			}

			if (item.todas && item.todas !== '') {
				var todas = $('#js-todas').clone().removeAttr('id').find('a').attr('href', item.todas);
				$li = $('<li/>');
				$containerSubCats.append($li.append(todas));
			}

			// Botones

			$button.on('click', function () {
				_showHideSubCats($button, $containerSubCats);
			});

			$buttonMobile.on('click', function () {
				_showHideSubCats($buttonMobile, $containerSubCats);
			});

			$container.append($domNode);
		};

		for (var i = 0; i < list.length; i++) {
			_loop(i);
		}
	};

	var _showHideSubCats = function _showHideSubCats($trigger, $listSubCats) {
		var activa = $trigger.hasClass('activa') ? true : false;

		$('.js-selector-subcat-mobile').removeClass('activa');
		$('.js-selector-subcat').removeClass('activa');
		$('.js-lista-subcat').removeClass('activa');

		if (!activa) {
			$trigger.addClass('activa');
			$listSubCats.addClass('activa');
		} else {
			$trigger.removeClass('activa');
			$listSubCats.removeClass('activa');
		}
	};

	return {
		init: _init
	};
}();